<template>
  <Modal :id="id" :title="modalTitle" :hideClose="true">
    <div slot="body" class="modal-body modal-form">
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <Field
              type="datepicker"
              name="start_date"
              label="Start Date"
              v-model="blockout.start_date"
              validate="required"
              validate-as="Start Date"
            />
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <Field
              type="datepicker"
              name="end_date"
              label="End Date"
              v-model="blockout.end_date"
              validate="required"
              validate-as="End Date"
            />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <Field
              type="text"
              name="reason"
              label="Reason"
              v-model="blockout.reason"
              validate="required"
              validate-as="Reason"
            />
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="modal-footer">
      <a class="btn btn-success" href="#" @click.prevent="save">Save</a>
      <a v-if="isEdit" class="btn btn-danger" href="#" @click.prevent="destroy"
        >Delete</a
      >
      <a class="btn btn-info" href="#" @click.prevent="close">Cancel</a>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";

export default {
  mixins: [ModalMixin],

  data() {
    return {
      id: "edit-calendar-blockout-modal",
      blockout: {
        id: null,
        start_date: null,
        end_date: null,
        reason: "",
      },
      eventBus: null,
    };
  },

  computed: {
    isEdit() {
      return !!this.blockout && !!this.blockout.id;
    },
    modalTitle() {
      return this.isEdit ? "Edit Block" : "Add New Block";
    },
  },

  watch: {
    blockout(val) {
      this.load();
    },
  },

  methods: {
    load() {
      if (typeof this.blockout.start_date == "string") {
        this.blockout.start_date = new Date(
          `${this.blockout.start_date} 12:00:00`
        );
      }
      if (typeof this.blockout.end_date == "string") {
        this.blockout.end_date = new Date(`${this.blockout.end_date} 12:00:00`);
      }
    },

    save() {
      let required = ["start_date", "end_date", "reason"];
      let empty = required.filter((field) => {
        var value = this.blockout[field] || null;
        return !value;
      });
      if (empty.length > 0) {
        alert("Please fill in all fields before continuing.");
        return;
      }
      this.resolve(this.blockout);
    },

    destroy() {
      if (this.eventBus) {
        if (confirm("Are you sure you would like to remove this busy block?")) {
          this.eventBus.$emit("delete-blockout", this.blockout);
          this.close();
        }
      }
    },
  },

  mounted() {
    this.blockout = _.cloneDeep(this.options.blockout);
    this.eventBus = this.options.eventBus || null;
    this.load();
  },
};
</script>